// store/slices/drawingSlice.ts

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { DrawFeature, DrawGeometry, DrawingMode, DrawState } from "../../plugins/draw/types";
import { DRAW_FEATURE_COLOR, DRAW_FEATURE_KEY, DRAW_FEATURE_STROKE_COLOR, DRAW_FEATURE_STROKE_WIDTH } from "../../plugins/draw/consts";

const initialState: DrawState = {
  mode: "NONE",
  features: [],
  editingFeatureId: null,
  featureToDelete: null,
  counters: {},
};

const drawSlice = createSlice({
  name: "draw",
  initialState,
  reducers: {
    setDrawingMode(state, action: PayloadAction<DrawingMode>)
    {
      state.mode = action.payload;
      if (state.mode !== "EDIT")
      {
        state.editingFeatureId = null;
      }
    },
    setFeatures(state, action: PayloadAction<DrawFeature[]>)
    {
      state.features = action.payload;
    },
    setEditingFeatureId(state, action: PayloadAction<string | null>)
    {
      state.editingFeatureId = action.payload;
    },
    setFeatureToDelete(state, action: PayloadAction<string | null>)
    {
      state.featureToDelete = action.payload;
      state.features = state.features.filter((f) => f.id !== action.payload);
      state.editingFeatureId = null;
    },
    addFeature(
      state,
      action: PayloadAction<{
        id?: string;
        geometry: DrawGeometry;
        label?: string;
        fill?: string;
        stroke?: string;
        strokeWidth?: number;
        createdAt?: number;
        properties?: Record<string, any>;
      }>,
    )
    {
      const { id, geometry, label, fill, stroke, strokeWidth, createdAt, properties } = action.payload;
      const featureType = geometry.type;
      const counterValue = state.counters[featureType] ?? 0;
      state.counters = {
        ...state.counters,
        [featureType]: counterValue + 1,
      };
      const feat: DrawFeature = {
        id: id || `${DRAW_FEATURE_KEY}-${crypto.randomUUID()}`,
        geometry,
        label: label?.trim() || `${featureType} ${counterValue + 1}`,
        fill: fill || DRAW_FEATURE_COLOR,
        stroke: stroke || DRAW_FEATURE_STROKE_COLOR,
        strokeWidth: strokeWidth || DRAW_FEATURE_STROKE_WIDTH,
        properties: {
          ...properties,
          color: fill || DRAW_FEATURE_COLOR,
          fill: fill || DRAW_FEATURE_COLOR,
          stroke: stroke || DRAW_FEATURE_STROKE_COLOR,
          stroke_color: stroke || DRAW_FEATURE_STROKE_COLOR,
          stroke_width: strokeWidth || DRAW_FEATURE_STROKE_WIDTH,
        },

        createdAt: createdAt || Date.now(),
      };
      state.features.push(feat);
    },
    // updateFeature(state, action: PayloadAction<{ id: string; geometry: DrawGeometry }>) {
    //   const { id, geometry } = action.payload;
    //   const featureIndex = state.features.findIndex((feature) => feature.id === id);
    //   if (featureIndex !== -1) {
    //     state.features[featureIndex].geometry = geometry;
    //   }
    // },

    updateFeature(
      state,
      action: PayloadAction<{
        id: string;
        geometry: DrawGeometry;
        label?: string;
        fill?: string;
        stroke?: string;
        strokeWidth?: number;
        properties?: Record<string, any>;
        createdAt?: number;
      }>,
    )
    {
      const { id, geometry, label, fill, stroke, strokeWidth, properties, createdAt } = action.payload;
      const featureIndex = state.features.findIndex((feature) => feature.id === id);

      if (featureIndex >= 0)
      {
        state.features[featureIndex].geometry = geometry;
        state.features[featureIndex].properties = { ...state.features[featureIndex].properties, ...properties };
      } else
      {
        const featureType = geometry.type;
        const counterValue = state.counters[featureType] ?? 0;
        state.counters = {
          ...state.counters,
          [featureType]: counterValue + 1,
        };

        const feat: DrawFeature = {
          id: id || `${DRAW_FEATURE_KEY}-${crypto.randomUUID()}`,
          geometry,
          label: label?.trim() || `${featureType} ${counterValue + 1}`,
          fill: fill || DRAW_FEATURE_COLOR,
          stroke: stroke || DRAW_FEATURE_STROKE_COLOR,
          strokeWidth: strokeWidth || DRAW_FEATURE_STROKE_WIDTH,
          // properties: properties || {},
          properties: {
            ...properties,
            color: fill || DRAW_FEATURE_COLOR,
            fill: fill || DRAW_FEATURE_COLOR,
            stroke: stroke || DRAW_FEATURE_STROKE_COLOR,
            stroke_color: stroke || DRAW_FEATURE_STROKE_COLOR,
            stroke_width: strokeWidth || DRAW_FEATURE_STROKE_WIDTH,
          },

          createdAt: createdAt || Date.now(),
        };
        console.log(feat);

        // console.log(fill, stroke, '123');
        state.features.push(feat);
      }
    },
    removeFeature(state, action: PayloadAction<string>)
    {
      state.featureToDelete = action.payload;
      state.features = state.features.filter((feature) => feature.id !== action.payload);
      state.editingFeatureId = null;
    },
    clearFeatures(state)
    {
      state.featureToDelete = "__ALL__";
      state.features = [];
      state.editingFeatureId = null;
    },


  },
});

export const { setDrawingMode, setFeatures, setEditingFeatureId, setFeatureToDelete, addFeature, updateFeature, removeFeature, clearFeatures } =
  drawSlice.actions;
export default drawSlice.reducer;
